import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronRight2 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.5227 7.10229L15.0227 11.6023C15.2287 11.8082 15.2418 12.1343 15.0615 12.3552L15.0227 12.3977L10.5227 16.8977L9.72729 16.1023L13.8296 12L9.72729 7.8977L10.5227 7.10229Z",
		fill: "#505258"
	})
});
export default SvgChevronRight2;
